
(function(){
  function initPreviews(root){
    root.querySelectorAll('.ol-stream-preview[data-source]').forEach(button=>{
      if(button.querySelector('img')||button.dataset.previewReady)return;
      let url;try{url=new URL(button.dataset.source);}catch{return;}
      if(['youtube.com','www.youtube.com','m.youtube.com','youtu.be','www.youtu.be'].includes(url.hostname)){
        const parts=url.pathname.split('/').filter(Boolean);
        const id=url.hostname.endsWith('youtu.be')?parts[0]:parts[0]==='watch'?url.searchParams.get('v'):['live','embed','shorts'].includes(parts[0])?parts[1]:null;
        if(!id||!/^[a-zA-Z0-9_-]{11}$/.test(id))return;
        button.dataset.previewReady='true';
        const image=document.createElement('img');image.alt='';image.width=480;image.height=360;image.loading='lazy';image.decoding='async';image.src='https://i.ytimg.com/vi/'+id+'/hqdefault.jpg';
        image.addEventListener('error',()=>image.remove());button.prepend(image);return;
      }
      if(!['twitch.tv','www.twitch.tv','m.twitch.tv'].includes(url.hostname))return;
      const channel=url.pathname.split('/').filter(Boolean);
      if(channel.length!==1||!/^[a-zA-Z0-9_]{1,25}$/.test(channel[0]))return;
      button.dataset.previewReady='true';
      const image=document.createElement('img');image.alt='';image.width=640;image.height=360;image.loading='lazy';image.decoding='async';
      const source='https://static-cdn.jtvnw.net/previews-ttv/live_user_'+channel[0].toLowerCase()+'-640x360.jpg';
      function refresh(){if(document.hidden||!button.isConnected)return;image.src=source+'?t='+Math.floor(Date.now()/300000);}
      image.addEventListener('error',()=>{image.style.visibility='hidden';});image.addEventListener('load',()=>{image.style.visibility='visible';});
      button.prepend(image);refresh();
      const timer=setInterval(()=>{if(!button.isConnected){clearInterval(timer);return;}refresh();},300000);
    });
  }
  initPreviews(document);
  document.addEventListener('shopify:section:load',event=>initPreviews(event.target));
})();

function setupLiveDirectory(){document.querySelectorAll('.ol').forEach(root=>{if(root.dataset.directoryReady)return;root.dataset.directoryReady='true';let mode='all';const search=root.querySelector('[data-ol-search]');const cards=[...root.querySelectorAll('[data-ol-status]')];const buttons=[...root.querySelectorAll('[data-ol-filter]')];function filter(){let count=0;const term=(search?.value||'').trim().toLowerCase();cards.forEach(card=>{const show=(mode==='all'||card.dataset.olStatus==='live')&&card.dataset.olName.toLowerCase().includes(term);card.hidden=!show;if(show)count++;});const empty=root.querySelector('[data-ol-no-results]');if(empty)empty.hidden=count>0||(cards.length===0&&mode==='all'&&!term);root.querySelectorAll('[data-ol-placeholder]').forEach(slot=>{slot.hidden=mode!=='all'||!!term;});const invitation=root.querySelector('.ol-empty');if(invitation)invitation.hidden=mode!=='all'||!!term;}buttons.forEach(button=>button.addEventListener('click',()=>{mode=button.dataset.olFilter;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));filter();}));search?.addEventListener('input',filter);root.addEventListener('oneness:live-status',filter);filter();});}setupLiveDirectory();document.addEventListener('shopify:section:load',setupLiveDirectory);

document.addEventListener('click',function(event){const link=event.target.closest('[data-ol-apply]');if(!link)return;const target=document.getElementById(link.hash.slice(1));const details=target?.querySelector('details');if(details)details.open=true;});
function openLiveApplication(){document.querySelectorAll('.ol-application').forEach(details=>{if(details.querySelector('[role="status"],[role="alert"]')||location.hash.includes('LiveApplication'))details.open=true;});}openLiveApplication();document.addEventListener('shopify:section:load',openLiveApplication);

(function(){
  function styleCreatorDisclaimer(){
    const section=document.querySelector('.ol-apply-wrap');
    if(!section)return;
    let attempts=0;
    function apply(){
      attempts++;
      const host=section.querySelector('shopify-forms-embed');
      const root=host?.shadowRoot;
      if(!root?.querySelector('[class*="_formDisclaimer_"]'))return false;
      if(!root.querySelector('#oneness-disclaimer-size')){
        const style=document.createElement('style');
        style.id='oneness-disclaimer-size';
        style.textContent='div[class*="_formDisclaimer_"],div[class*="_formDisclaimer_"] p{font-size:12px!important;line-height:18px!important}';
        root.append(style);
      }
      return true;
    }
    if(apply())return;
    const timer=setInterval(()=>{if(!section.isConnected||apply()||attempts>=80)clearInterval(timer);},250);
  }
  styleCreatorDisclaimer();
  document.addEventListener('shopify:section:load',styleCreatorDisclaimer);
})();


